import {
  editedHistoricalCells,
  historicalRowCounts,
  type AnswersBody,
  type CompiledForm,
  type FieldValue,
  type MatrixAnswers,
  type TableChanges,
} from '@record-fill';

// On creation the server resets to its default any editable field missing from the body, so the
// body carries every field the subject can edit, including the ones still holding the builder
// default and the ones a rule hides right now: a hidden field can still trigger another rule.
// A later response is the opposite: the server keeps from the last photo every field the body
// leaves out and requires every field it carries, so only `writtenFieldIds` go, or an untouched
// empty required field would refuse a response that only adds a row.
// Table rows: the server already holds the historical ones and takes every row in the body as
// new, so only the rows this response adds are sent, plus the cells it edits in the author's rows.
export function buildAnswersSnapshot(
  form: CompiledForm,
  answers: MatrixAnswers,
  writtenFieldIds?: readonly string[],
  opened?: MatrixAnswers
): AnswersBody {
  const values: Record<string, FieldValue> = {};
  const written = writtenFieldIds ? new Set(writtenFieldIds) : null;

  for (const fieldId of form.fieldOrder) {
    const field = form.fields[fieldId];
    if (field.state.editable && (written?.has(fieldId) ?? true)) {
      values[fieldId] = field.value;
    }
  }

  const historical = historicalRowCounts(form);
  const edited = opened ? editedHistoricalCells(opened, answers) : {};
  const tables: Record<string, TableChanges> = {};
  for (const [tableId, entry] of Object.entries(answers.tables)) {
    tables[tableId] = { extraRows: entry.extraRows.slice(historical[tableId] ?? 0) };
    if (edited[tableId]) tables[tableId].editedRows = edited[tableId];
  }

  return {
    version: answers.version,
    matrixId: answers.matrixId,
    values,
    tables,
  };
}
